import React from 'react';

function Home() {
  return (
    <div>
        <div>
            <h1>Bem-vindo ao sistema de gerenciamento da clínica veterinária!</h1>
            <p>Aqui você pode gerenciar todas as operações da clínica.</p>
        </div>
    </div>
  );
}

export default Home;